<input
    type="text"
    class="search-input"
    [(ngModel)]="searchValue"
    (ngModelChange)="onSearch()"
    placeholder="Search..."/>

@if (filteredCellData.length) {
    <cc-checkbox
        class="select-all"
        [label]="'(Select All)'"
        [(value)]="selectAll"
        (valueChange)="onSelectAll()">
    </cc-checkbox>
    <ul class="column-values">
        @for (item of filteredCellData | filter: searchValue : 'text'; track item.value) {
            <li>
                <cc-checkbox
                    [label]="!searchValue ? item.text : ''"
                    [(value)]="item.checked"
                    (valueChange)="onCheckChanged()">
                    @if (!!searchValue) {
                        <label [innerHTML]="searchValue && item.text | highlight: searchValue"></label>
                    }
                </cc-checkbox>
            </li>
        }
    </ul>
} @else {
    <div class="no-data error">
        <span>No Matches!</span>
    </div>
}

